import Logger, { debug } from './Logger'

export { debug }
export default Logger
